import styled from "styled-components";

export const TextField = styled.input`
  background: ${(props) => props.theme.colors.GREY_1};
  height: 10rem;
  width: 100%;
  border-radius: 1.5rem;
  border: ${(props) =>
    props.error ? `0.3rem solid ${props.theme.colors.RED}` : "none"};
  font-size: 3.4rem;
  padding: 1rem 3rem;
  box-sizing: border-box;
  caret-color: ${(props) => props.theme.colors.SELECTED};

  ::placeholder {
    color: ${(props) =>
      props.error ? props.theme.colors.RED : props.theme.colors.GREY_2};
  }

  :focus {
    outline: none;
    border: ${(props) => `0.3rem solid ${props.theme.colors.SELECTED}`};
    box-shadow: none;
  }
`;
